import { toast } from "react-toastify";
import api from "../../../../../../features/auth/axiosConfig";
import { postCategory, postCustomer } from "src/shared/services/servicesv2";

export const useCustomerActions = (
  setCustomerName: (v: string) => void,
  setPhoneNumber: (v: string) => void,
  setTableNumber: (v: string) => void,
  setCustomerAdd: (v: boolean) => void,
) => {
  /** 🔹 Close/reset customer modal */
  const handleCloseCustomer = () => {
    setCustomerAdd(false);
    setCustomerName("");
    setPhoneNumber("");
    setTableNumber("");
  };

  /** 🔹 Create a new customer */
  const createCustomer = async (name: string, phone: string, table: string) => {
    try {
      const res = await postCategory({
        firstName: name,
        phones: [
          {
            phone: phone,
            isPrimary: true,
          },
        ],
      });
      return res.data._id;
    } catch (err: any) {
      if (err?.response?.data?.message === "Phone number already exists.") {
        toast.error("Phone number already exists.");
      } else {
        toast.error("Error creating customer");
      }
      return null;
    }
  };

  /** 🔹 Create or fetch Unknown (Walk-in) Customer */
  const createUnknownCustomer = async () => {
    const UNKNOWN_NAME = "Walk-in Customer";
    const UNKNOWN_PHONE = "00000000";

    try {
      // ✅ Search existing customer first
      const res = await api.get(`/app/pos/v2/customer?searchBy=${UNKNOWN_PHONE}&pageNumber=1&pageSize=10`);

      // ✅ Find matching customer
      const customers = res.data?.result || res.data?.customer_details || [];

      const existingCustomer = customers.find((cust: any) => cust?.phones?.some((p: any) => p?.phone === UNKNOWN_PHONE));

      // ✅ If customer exists return ID
      if (existingCustomer) {
        return existingCustomer?._id?.$oid || existingCustomer?._id || existingCustomer?.customerId;
      }

      // ✅ Create only if NOT exists
      const payload = {
        firstName: UNKNOWN_NAME,
        phones: [
          {
            phone: UNKNOWN_PHONE,
            isPrimary: true,
          },
        ],
      };

      const createRes = await postCustomer(payload);

      return createRes.data?._id?.$oid || createRes.data?._id;
    } catch (error: any) {
      console.error("Failed to create/fetch walk-in customer", error);

      // ✅ If duplicate error happens, search again and return existing customer
      if (error?.response?.data?.message?.includes("Primary phone already exists")) {
        try {
          const retryRes = await api.get(`/app/pos/v2/customer?searchBy=${UNKNOWN_PHONE}&pageNumber=1&pageSize=10`);

          const customers = retryRes.data?.result || retryRes.data?.customer_details || [];

          const existingCustomer = customers.find((cust: any) => cust?.phones?.some((p: any) => p?.phone === UNKNOWN_PHONE));

          if (existingCustomer) {
            return existingCustomer?._id?.$oid || existingCustomer?._id || existingCustomer?.customerId;
          }
        } catch (retryError) {
          console.error("Retry search failed", retryError);
        }
      }

      return null;
    }
  };

  return {
    handleCloseCustomer,
    createCustomer,
    createUnknownCustomer, // ✅ Exported via returned object
  };
};
